
import { useContext, useMemo, useState, useEffect, useRef } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./LPCompSuctDrumB.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";
import { simulateCooler } from "../processEngines/CoolerEngine";
import SingleStageCompressorFaceplate from "../components/SingleStageCompressor/SingleStageCompressorFaceplate";
import {simulateSingleStageCompressor, startCompressor, stopCompressor, updateCompressor, createCompressorState} from "../components/SingleStageCompressor/SingleStageCompressorEngine";
import CompressorTrendFaceplate from "../components/SingleStageCompressor/CompressorTrendFaceplate";
import { CompressorContext } from "../context/CompressorContext";

import { trackPageVisit } from "../competency/PageTracker";




 
      /*  CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function LPCompSuctDrumB() {

        useEffect(() => {
  
    trackPageVisit("LPCompSuctDrumB");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);
  
    const { pumpData } = useContext(PumpContext);
    const [showTrend, setShowTrend] = useState(false);

    


const { compressorA, compressorB } = useContext(CompressorContext);

const compressor = compressorB; // or A depending on page
    

    const [open, setOpen] = useState(false);
    // ======================================
    // FORCE UI REFRESH FOR COMPRESSOR STATE
    // ======================================

    const [, forceRender] = useState(0);

    useEffect(() => {

      const interval = setInterval(() => {

        forceRender(v => v + 1);

      }, 100);

      return () => clearInterval(interval);

    }, []);

    

    
      const historianData = useMemo(() => {
  return {
    time: compressor.history?.time || [],
    PT_suction: compressor.history?.PT_suction || [],
    PT_discharge: compressor.history?.PT_discharge || [],
    TT_suction: compressor.history?.TT_suction || [],
    TT_discharge: compressor.history?.TT_discharge || [],
    FIC_suction: compressor.history?.FIC_suction || [],
    FIC_discharge: compressor.history?.FIC_discharge || [],
    speed: compressor.history?.speed || []
  };
}, [compressor.history]);




  const DEFAULT_VALVES = {
  FCV_17001B: { mode: "Manual", opening: 0, sp: "", pv: "" },
  PCV_17001B: { mode: "Manual", opening: 0, sp: "", pv: "" },
  PCV_17002B: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("LPCompSuctDrumB_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_17001B: { ...DEFAULT_VALVES.FCV_17001B, ...parsed.FCV_17001B },
      PCV_17001B: { ...DEFAULT_VALVES.PCV_17001B, ...parsed.PCV_17001B },
      PCV_17002B: { ...DEFAULT_VALVES.PCV_17002B, ...parsed.PCV_17002B },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("LPCompSuctDrumB_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};


// ================= RETREIVING STORED TRANSMITTERS FROM LOCAL STORAGE IN OTHER PAGES GOING TO LP COMPRESSOR =================

  const [FIC_15004, setFIC_15004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_15004")) || 0;
            setFIC_15004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_15004, setPT_15004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_15004")) || 0;
            setPT_15004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_15004, setTT_15004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_15004")) || 0;
            setTT_15004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);



  /* ================= VALVE STATUS ================= */

  const isXV17001BOpen = valves?.XV_17001B === false;
  const isXV17002BOpen = valves?.XV_17002B === false;
  const isXV17003BOpen = valves?.XV_17003B === false;
  const isXV17004BOpen = valves?.XV_17004B === false;
  const isXV17005BOpen = valves?.XV_17005B === false;
  const isXV17006BOpen = valves?.XV_17006B === false;

    const isP17001BOn = pumpData?.["P-17001B"]?.running ?? false;




 const FIC_17001B = isXV17001BOpen ? FIC_15004 : 0;
 const PT_17001B = isXV17001BOpen ? PT_15004 : 0.03;
 const TT_17001B = isXV17001BOpen ? TT_15004 : 22;


const FIC_17004B = isXV17006BOpen ? 30.54 : 0;
const PT_17006B = isXV17006BOpen ? 1.3 : 0.03;
const TT_17004B = isXV17006BOpen ? 24 : 28;


const coolerResults = simulateCooler({

  coolerId: "LP_COOLER_B",

  gasFlow: FIC_17001B,
  gasTempIn: TT_17001B,
  gasPressureIn: PT_17001B,

  waterFlow: FIC_17004B,
  waterTempIn: TT_17004B,
  waterPressureIn: PT_17006B,

  gasValveOpen: isXV17001BOpen,
  waterValveOpen: isXV17006BOpen,

  designEfficiency: 0.84,

  foulingFactor: 0.02
});




const TT_17003B = isXV17001BOpen && !isXV17006BOpen? TT_17001B : (isXV17001BOpen) ? 
  coolerResults.gasTempOut*0.45 : 24;

const PT_17002B = isXV17001BOpen && !isXV17006BOpen? PT_17001B : (isXV17001BOpen) ? 
  coolerResults.gasPressureOut*0.212 : 0.03;

const TT_17002B = isXV17001BOpen && !isXV17006BOpen? TT_17004B : (isXV17001BOpen) ? 
  coolerResults.waterTempOut*1.24 : TT_17004B;


const TT_17005B = TT_17003B * 0.95;

const FIC_17006B = FIC_17001B * 0.78;

const PT_17003B =  isXV17005BOpen ? PT_17002B * ((valveData?.PCV_17001B?.opening || 0)/100) : 0.03;



// ======================================================
// SINGLE STAGE COMPRESSOR SIMULATION
// ======================================================

const compressorResults =
  simulateSingleStageCompressor({

    suctionPressure: PT_17003B,
    suctionTemperature: TT_17005B,
    suctionFlow: FIC_17006B,

    isRunning: compressor.running,

    compressorEfficiency: 0.82,

    compressionRatio: 2.8
  });

useEffect(() => {

  const interval = setInterval(() => {

    updateCompressor(compressor, {
      suctionPressure: PT_17003B,
      suctionTemperature: TT_17005B,
      suctionFlow: FIC_17006B
    });

    forceRender(v => v + 1);

  }, 200); // DCS-like scan time

  return () => clearInterval(interval);

}, [PT_17003B, TT_17005B, FIC_17006B]);

// ======================================================
// DISCHARGE VALUES
// ======================================================

const FIC_17003B =
  compressorResults.dischargeFlow*1.22;

const PT_17008B =
  compressorResults.dischargePressure*9.3;

const TT_17008B =
  compressorResults.dischargeTemperature;

const PT_17004B = isXV17004BOpen ? 0.3 : 0.03;
const FIC_17008B = isXV17004BOpen ? 1.432 : 0;
const FIC_17007B = compressor.running ? 1.3 + 1.432 : FIC_17008B;

const FIC_17002B = FIC_17003B * 0.3 * (valveData?.PCV_17002B?.opening || 0)/100;

  
  // ================= LP CONDENSATE PUMP (B) =================

const runningPumps17001B = [isP17001BOn].filter(Boolean).length;


// ================= SUCTION INPUTS =================
const suctionFlow17001B = 0;
const suctionPressure17004B = PT_17004B;

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_170051B =  1.3 * (valveData?.FCV_17001B?.opening || 0)/100;
const MIN_DISCH_PRESSURE_170051B = 0.5;

// ================= TARGET CALCULATIONS =================
let targetPT_170051B = MAX_DISCH_PRESSURE_170051B;
let targetFIC_17005B = 0;

if (runningPumps17001B > 0) {

  // 🔹 Flow boost
  targetFIC_17005B = isXV17004BOpen ? 50 * (valveData?.FCV_17001B?.opening || 0)/100 : 0;

  // 🔹 Pressure rises to design max
  targetPT_170051B = isXV17004BOpen ? MIN_DISCH_PRESSURE_170051B* (valveData?.FCV_17001B?.opening || 0)/100 : 0.03;

}

// ================= STATES =================
const [PT_170051B, setPT_170051B] = useState(() => {
  return Number(localStorage.getItem("PT_170051B")) || 0.03;
});

const [FIC_17005B, setFIC_17005B] = useState(() => {
  return Number(localStorage.getItem("FIC_17005B")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_170051B(prev => {
      const next = prev + (targetPT_170051B - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_17005B(prev => {
      const next = prev + (targetFIC_17005B - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast response like DCS

  return () => clearInterval(interval);

}, [targetPT_170051B, targetFIC_17005B]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_170051B", PT_170051B);
}, [PT_170051B]);

useEffect(() => {
  localStorage.setItem("FIC_17005B", FIC_17005B);
}, [FIC_17005B]);


useEffect(() => {
  localStorage.setItem("FIC_17003B", FIC_17003B);
}, [FIC_17003B]);

useEffect(() => {
  localStorage.setItem("PT_17008B", PT_17008B);
}, [PT_17008B]);

useEffect(() => {
  localStorage.setItem("TT_17008B", TT_17008B);
}, [TT_17008B]);








  return (
    <div className="LPCompSuctDrumB-container"> 
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "230px",
        color: "white",
        background: "rgba(30, 5, 250, 0.98)", 
        padding: "2px 200px"
      }}>
        LP COMPRESSOR SUCTION DRUM (B)
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2971 */}
      <Valve
        className="XV-17001B"
        tag="XV_17001B"
        x={115}
        y={122}
        isClosed={valves.XV_17001B}
        toggle={toggleValve}
      />

      {/* XV-17002B */}
      <Valve
        className="XV-17002B"
        tag="XV_17002B"
        x={878}
        y={186}
        isClosed={valves.XV_17002B}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-17003A */}
      <Valve
        className="XV-17003B"
        tag="XV_17003B"
        x={1025}
        y={186}
        isClosed={valves.XV_17003B}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-17004B */}
      <Valve
        className="XV-17004B"
        tag="XV_17004B"
        x={571}
        y={620}
        isClosed={valves.XV_17004B}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-17005B */}
      <Valve
        className="XV-17005B"
        tag="XV_17005B"
        x={882}
        y={596}
        isClosed={valves.XV_17005B}
        toggle={toggleValve}
        r={270}
      />

      
      {/* XV-17006B */}
      <Valve
        className="XV-17006B"
        tag="XV_17006B"
        x={286}
        y={502}
        isClosed={valves.XV_17006B}
        toggle={toggleValve}
      />

      
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-17001B */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-17001B"
          style={{ position: "absolute", left: 92, top: 722}}  onClick={() => openPanel("FCV_17001B")}>
          
          <defs>
            <linearGradient id="metal_17001B">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_17001B)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_17001B)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

         {/* PCV-17001B */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="PCV-17001B"
          style={{ position: "absolute", left: 855, top: 520, transform: "rotate(270deg)", transformOrigin: "center"}}  onClick={() => openPanel("PCV_17001B")}>
          
          <defs>
            <linearGradient id="metal_17001B">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_17001B)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_17001B)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


         {/* PCV-17002B */}
        <svg width="30" height="30" viewBox="0 0 200 220" className="PCV-17002B"
          style={{ position: "absolute", left: 707, top: 64}}  onClick={() => openPanel("PCV_17002B")}>
          
          <defs>
            <linearGradient id="metal_17002B">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_17002B)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_17002B)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


        

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          <div
              onClick={() => setOpen(true)}
              style={{
                position: "absolute",
                left: 900,
                top: 350,
                width: 150,
                height: 30,

                background:

                  compressor.status === "RUNNING"
                    ? "#00aa00"

                  : compressor.status === "STARTING"
                    ? "#d4aa00"

                  : compressor.status === "SHUTTING DOWN"
                    ? "#ff8800"

                  : compressor.status === "READY"
                    ? "#0099ff"

                  : compressor.status === "TRIPPED"
                    ? "#ff3300"

                  : "#666666",

                color: "white",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                border: "2px solid cyan",

                cursor: "pointer",

                fontWeight: "bold",

                borderRadius: "8px",

                boxShadow:
                  compressor.running
                    ? "0 0 15px lime"
                    : "0 0 10px red",

                transition: "0.3s"
              }}
            >
              {compressor.status}
            </div>


          {open && (
            <SingleStageCompressorFaceplate
              input={{
                PT_17003B,
                TT_17005B,
                FIC_17006B,
                FIC_17003B,
                PT_17008B,
                TT_17008B,
                isXV17001BOpen,
                isXV17006BOpen
              }}
              compressor={compressor}
              close={() => setOpen(false)}
              openTrend={() => setShowTrend(true)}
            />
          )}




          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_17001B?.opening || 0)}
        x={117}
        y={762}
      />
      <ValveOutput
        value={Number(valveData?.PCV_17001B?.opening || 0)}
        x={915}
        y={535}
      />
      <ValveOutput
        value={Number(valveData?.PCV_17002B?.opening || 0)}
        x={707}
        y={90}
      />



          {/* ================= TRANSMITTERS OUTPUTS ================= */}

      <Transmitter
        tag="FIC-17001B"
        value={[FIC_17001B]}
        x={226}
        y={117}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS FROM 3RD STAGE SEPARATOR GAS OUTLET TO SUCTION DRUM OF LP COMPRESSOR"
      />

      <Transmitter
        tag="PT-17001B"
        value={[PT_17001B]}
        x={226}
        y={167}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF GAS FROM 3RD STAGE SEPARATOR GAS OUTLET TO SUCTION DRUM OF LP COMPRESSOR"
      />
      
      <Transmitter
        tag="TT-17001B"
        value={[TT_17001B]}
        x={326}
        y={117}
        unit="°C"
        max={100}
        HH={90}
        H={80}
        L={14}
        LL={5}
        c="lime"
        description="TEMPERATURE OF GAS FROM 3RD STAGE SEPARATOR GAS OUTLET TO SUCTION DRUM OF LP COMPRESSOR"
      />
      
      <Transmitter
        tag="TT-17004B"
        value={[TT_17004B]}
        x={426}
        y={333}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF WATER FROM FRESH WATER SUPPLY TO LP GAS COOLER (B) FOR HEAT EXCHANGING WITH GAS"
      />

      <Transmitter
        tag="PT-17006B"
        value={[PT_17006B]}
        x={426}
        y={373}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF WATER FROM FRESH WATER SUPPLY TO LP GAS COOLER (B) FOR HEAT EXCHANGING WITH GAS"
      />

      <Transmitter
        tag="FIC-17004B"
        value={[FIC_17004B]}
        x={146}
        y={493}
        unit="LPM"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF WATER FROM FRESH WATER SUPPLY TO LP GAS COOLER (B) FOR HEAT EXCHANGING WITH GAS"
      />


      <Transmitter
        tag="TT-17003B"
        value={[TT_17003B]}
        x={258}
        y={333}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF COOLED GAS AT THE DISCHARGE OF THE LP GAS COOLER (B) TO LP COMPRESSOR SUCTION DRUM (B)"
      />

      <Transmitter
        tag="PT-17002B"
        value={[PT_17002B]}
        x={676}
        y={269}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF COOLED GAS AT THE DISCHARGE OF THE LP GAS COOLER (B) TO LP COMPRESSOR SUCTION DRUM (B)"
      />

      <Transmitter
        tag="TT-17002B"
        value={[TT_17002B]}
        x={543}
        y={116}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF WATER AT THE DISCHARGE OF THE LP GAS COOLER (B) TO FRESH WATER RETURN LINE"
      />
      <Transmitter
        tag="TT-17005B"
        value={[TT_17005B]}
        x={920}
        y={666}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF GAS AT THE SUCTION OF LP COMPRESSOR (B)"
      />

      <Transmitter
        tag="FIC-17006B"
        value={[FIC_17006B]}
        x={826}
        y={666}
        unit="SCF/S"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE SUCTION OF LP COMPRESSOR (B)"
      />

      <Transmitter
        tag="PT-17003B"
        value={[PT_17003B]}
        x={776}
        y={492}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE SUCTION OF LP COMPRESSOR (B)"
      />
      
      <Transmitter
        tag="FIC-17003B"
        value={[FIC_17003B]}
        x={936}
        y={132}
        unit="SCF/S"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS AT THE DISCHARGE OF LP COMPRESSOR (B)"
      />

      <Transmitter
        tag="PT-17008B"
        value={[PT_17008B]}
        x={1036}
        y={132}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF GAS AT THE DISCHARGE OF LP COMPRESSOR (B)"
      />

      <Transmitter
        tag="TT-17008B"
        value={[TT_17008B]}
        x={1124}
        y={132}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF GAS AT THE DISCHARGE OF LP COMPRESSOR (B)"
      />

      <Transmitter
        tag="PT-17004B"
        value={[PT_17004B]}
        x={466}
        y={706}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF CRUDE AT THE BOTTOM LEVEL OF LP COMPRESSOR SUCTION DRUM (B) GOING TO LP CONDENSATE PUMP"
      />


      <Transmitter
        tag="FIC-17008B"
        value={[FIC_17008B]}
        x={656}
        y={720}
        unit="LPM"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE BOTTOM LEVEL OF LP COMPRESSOR SUCTION DRUM (B) GOING TO DE-OILER VESSEL"
      />

      <Transmitter
        tag="FIC-17005B"
        value={[FIC_17005B]}
        x={226}
        y={667}
        unit="LPM"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE DISCHARGE OF LP CONDENSATE PUMP (B) GOING BACK TO 3RD STAGE SEPARATOR"
      />

      <Transmitter
        tag="PT-170051B"
        value={[PT_170051B]}
        x={226}
        y={680}
        unit="MPa"
        max={1}
        HH={0.7}
        H={0.5}
        L={0.12}
        LL={0.08}
        c="lime"
        description="PRESSURE OF CRUDE AT THE DISCHARGE OF LP CONDENSATE PUMP (B) GOING BACK TO 3RD STAGE SEPARATOR"
      />


      <Transmitter
        tag="FIC-17002B"
        value={[FIC_17002B]}
        x={426}
        y={117}
        unit="SCF/S"
        max={100}
        HH={90}
        H={85}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF GAS RETURNED FROM THE DISCHARGE OF THE LP COMPRESSOR FOR ANTI-SURGE PROTECTION"
      />

      <Transmitter
        tag="FIC-17007B"
        value={[FIC_17007B]}
        x={1106}
        y={720}
        unit="LPM"
        max={10}
        HH={9}
        H={8}
        L={1}
        LL={0.5}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE BOTTOM LEVEL OF LP COMPRESSOR SUCTION DRUM (B) AND COMPRESSOR DURING PURGING AND BLOWDOWN GOING TO DE-OILER VESSEL"
      />










      <Pump
        tag="P-17001B"
        x={375}
        y={749}
        rpm={1800}
        bladeCount={pumpData?.["P-17001B"]?.bladeCount || 5}
        size={pumpData?.["P-17001B"]?.size || 35}
        onClick={openPumpPanel}
      />

      <LevelTransmitterIndicator
      tag="LT_17001B"
      totalLevel={100000}
      inflows={[FIC_17001B * 0.08]}
      outflows={[FIC_17005B]}
      responseFactor={0.05}
      columnX={626}
      columnY={410}
      columnWidth={52}
      columnHeight={147}
      textX={529}
      textY={470}
      showFlow={true}
      backgroundOpacity={0.2}
      liquidOpacity={0.8}
    />





      
           
          {showTrend && (
            <CompressorTrendFaceplate
              data={historianData}
              close={() => setShowTrend(false)}
            />
          )}


    </div>
  );
}


export default LPCompSuctDrumB;